var render = function render(){
  var _vm$listTargetAvailab;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', [_c('div', {
    staticClass: "d-flex justify-content-between my-3"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-multiselect', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "Search Fleet Type",
      "label": "name",
      "options": _vm.optionsFleetTypes,
      "multiple": true,
      "required": "",
      "track-by": "id"
    },
    on: {
      "input": _vm.fetchData
    },
    model: {
      value: _vm.params.vehicle_type_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "vehicle_type_ids", $$v);
      },
      expression: "params.vehicle_type_ids"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Fleet type not found.")])]), _c('date-picker', {
    attrs: {
      "type": "year"
    },
    on: {
      "change": _vm.fetchData
    },
    model: {
      value: _vm.params.year,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "year", $$v);
      },
      expression: "params.year"
    }
  })], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('b-button', {
    staticClass: "text-truncate",
    staticStyle: {
      "height": "max-content"
    },
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleExportTargetAv
    }
  }, [_vm._v(" Export ")])], 1)]), !_vm.loading ? [_c('div', {
    staticClass: "overflow-auto relative w-100"
  }, [_c('table', {
    staticClass: "w-100 striped-table"
  }, [_c('thead', [_c('th', {
    staticClass: "p-2 sticky col-1"
  }, [_vm._v("No")]), _c('th', {
    staticClass: "p-2 text-truncate sticky col-2"
  }, [_vm._v("Fleet Category")]), _c('th', {
    staticClass: "p-2 sticky col-3"
  }, [_vm._v("Year")]), _vm._l(_vm.target_per_months, function (month, index) {
    return _c('th', {
      key: index,
      staticClass: "p-2 col-month text-center"
    }, [_vm._v(_vm._s(month.name))]);
  })], 2), _c('tbody', [(_vm$listTargetAvailab = _vm.listTargetAvailabilities) !== null && _vm$listTargetAvailab !== void 0 && _vm$listTargetAvailab.length ? _vm._l(_vm.listTargetAvailabilities, function (item, index) {
    var _vm$params;
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "p-2 sticky col-1",
      class: index % 2 == 0 ? 'bg-striped' : 'bg-white'
    }, [_vm._v(_vm._s(_vm.getRowNumber(index)))]), _c('td', {
      staticClass: "p-2 text-truncate sticky col-2",
      class: index % 2 == 0 ? 'bg-striped' : 'bg-white'
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.name))]), _c('td', {
      staticClass: "p-2 sticky col-3",
      class: index % 2 == 0 ? 'bg-striped' : 'bg-white'
    }, [_vm._v(_vm._s(_vm.moment((_vm$params = _vm.params) === null || _vm$params === void 0 ? void 0 : _vm$params.year).format('YYYY')))]), _vm._l(item === null || item === void 0 ? void 0 : item.availability_permonth, function (month, index) {
      return _c('td', {
        key: index,
        staticClass: "p-2 col-month text-center"
      }, [_vm._v(_vm._s(month === null || month === void 0 ? void 0 : month.total) + "%")]);
    })], 2);
  }) : [_vm._m(0)]], 2)])]), _c('div', {
    staticClass: "mt-4 d-flex align-items-center w-100 justify-content-end"
  }, [_c('b-pagination', {
    staticClass: "mb-0 mr-3",
    attrs: {
      "total-rows": _vm.meta.totalItems,
      "per-page": _vm.meta.perPage,
      "first-number": "",
      "align": "center"
    },
    on: {
      "change": function change(page) {
        _vm.meta.page = page;
        _vm.fetchData();
      }
    },
    model: {
      value: _vm.meta.page,
      callback: function callback($$v) {
        _vm.$set(_vm.meta, "page", $$v);
      },
      expression: "meta.page"
    }
  }), _c('b-form-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "plain": "",
      "options": _vm.limitOptions
    },
    on: {
      "input": function input() {
        _vm.meta.page = 1;
        _vm.fetchData();
      }
    },
    model: {
      value: _vm.meta.perPage,
      callback: function callback($$v) {
        _vm.$set(_vm.meta, "perPage", $$v);
      },
      expression: "meta.perPage"
    }
  })], 1)] : _c('div', {
    staticClass: "d-flex justify-content-center p-5 w-100",
    attrs: {
      "colspan": "17"
    }
  }, [_c('b-spinner')], 1)], 2)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    staticClass: "col-1 sticky p-3",
    attrs: {
      "colspan": "17"
    }
  }, [_vm._v(" No data here! ")])]);

}]

export { render, staticRenderFns }